/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Media_Import_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to import media" |
*
* @param {Player_Media_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_media_import_failed = /** @type {((inputs?: Player_Media_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Media_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Echec de l'importation du media")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medien konnten nicht importiert werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile importare il supporto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось импортировать медиафайлы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo importar el medio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入媒体失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアのインポートに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया आयात करने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao importar mídia")
	return /** @type {LocalizedString} */ ("Failed to import media")
});